module.exports = __webpack_public_path__ + "static/media/Check.6d6643d1.svg";